import { i18n as _i18n } from "@lingui/core";
import { defaultFlow } from '@wkda/conversational-carlead';

/**
 * Chat-mode counterpart of carleadQuestionnaireWithBoughtOrOrderedCarQuestionPartialFlow:
 * BUY_CAR = NO asks BOUGHT_OR_ORDERED_CAR before email, BUY_CAR = YES goes straight to email.
 * Same field name, values and label ids as the manual form, so tracking, cookies and the
 * customerSurvey payload line up across both modes.
 */
export const boughtOrOrderedCarChatStep = {
  field: 'BOUGHT_OR_ORDERED_CAR',
  type: 'box-select',
  nodeType: 'questionnaireField',
  message: _i18n._(
  /*i18n*/
  {
    id: 'carleadCreation.form.label.boughtOrOrderedCar'
  }),
  answers: [{
    label: _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.option.buyCarYES'
    }),
    value: 'YES'
  }, {
    label: _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.option.buyCarNO'
    }),
    value: 'NO'
  }],
  next: [{
    values: ['YES', 'NO'],
    field: 'email'
  }]
};

/**
 * Inserts BOUGHT_OR_ORDERED_CAR after BUY_CAR and re-routes BUY_CAR = NO to it.
 * Shape matches BaseConversationalLeadPage's `customFlow(form)` prop.
 */
export function createBoughtOrOrderedCarChatFlow(baseFlow = defaultFlow) {
  return baseFlow.flatMap(step => {
    if (step.field !== 'BUY_CAR') {
      return [step];
    }
    return [{
      ...step,
      next: [{
        values: ['NO'],
        field: 'BOUGHT_OR_ORDERED_CAR'
      }, {
        values: ['YES'],
        field: 'email'
      }]
    }, boughtOrOrderedCarChatStep];
  });
}